import { render, staticRenderFns } from "./DataTableExtended.vue?vue&type=template&id=4fd14bce"
import script from "./DataTableExtended.vue?vue&type=script&lang=js"
export * from "./DataTableExtended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports